module.exports = __webpack_public_path__ + "static/media/Rugby-Romania-Logo.a94918e1.png";